import { TAlertsState, TAlertsActions } from '../../types/alerts';

export const alertsActionTypes = {
  GET_HISTORY_REQUEST: 'ALERTS/GET_HISTORY_REQUEST',
  GET_HISTORY_SUCCESS: 'ALERTS/GET_HISTORY_SUCCESS',
} as const;

const initialState: TAlertsState = {
  history: [],
};

export default (state: TAlertsState = initialState, action: TAlertsActions): TAlertsState => {
  switch (action.type) {
    case alertsActionTypes.GET_HISTORY_SUCCESS:
      return {
        ...state,
        history: action.payload,
      };
    default:
      return state;
  }
};

export const actions = {
  getHistoryRequest: () => ({ type: alertsActionTypes.GET_HISTORY_REQUEST }),
};
